import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { OnboardingSchema } from '@features/onboarding/schema/onboarding';
import { useAuthStore } from 'src/store/auth';
import { useOnboardingStore } from '@features/onboarding/store/onboarding';

export const HeaderMenu = () => {
  const { logout } = useAuthStore();
  const { resetData } = useOnboardingStore();
  const formOnbording = useForm<OnboardingSchema>();

  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleLogout = () => {
    formOnbording.reset({});
    resetData();
    logout();
    window.location.href = '/login';
  };

  return (
    <div className="absolute right-0 -mb-30 w-auto bg-white border border-gray-200 rounded-lg shadow-lg z-50">
      <button
        className="w-full text-left px-4 py-2 text-sm font-semibold text-primary hover:bg-gray-100 rounded-t-lg text-nowrap"
        onClick={() => {
          navigate('/healthhub');
          setDropdownOpen(false);
        }}
      >
        Profile
      </button>
      <button
        className="w-full text-left px-4 py-2 text-sm font-semibold text-primary hover:bg-gray-100 rounded-t-lg text-nowrap"
        onClick={handleLogout}
      >
        Logout
      </button>
    </div>
  );
};
